var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._v("基本信息")]),_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("@/assets/avatar.png"),"width":"100px","height":"100px","alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }